import React from 'react'
import {Dialog,Slide,DialogTitle,DialogContent,DialogContentText,DialogActions} from '@material-ui/core';
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const Alert=(props)=>{
const {children,isOpen=false,onClose,title,actions,onBackdropClick}=props;
  return(
    <Dialog
    open={isOpen}
    TransitionComponent={Transition}
    keepMounted
    onClose={onClose}
    aria-labelledby="alert-dialog-slide-title"
    aria-describedby="alert-dialog-slide-description"
    onBackdropClick={onBackdropClick}
  >
    <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-slide-description">
        {children}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      {actions}
    </DialogActions>
  </Dialog>
  )
}

export default Alert;